module.exports = __webpack_public_path__ + "static/media/weddings.3cb668b6.jpg";